const STORAGE_KEY = 'dontmiss.friendChallenge.pendingCode.v1';

export function parseChallengeCode(rawUrl: string): string | null {
  try {
    const url = new URL(rawUrl);
    const isChallenge = url.hostname === 'challenge' || url.pathname.replace(/\/+$/, '') === '/challenge';
    if (!isChallenge) return null;
    const code = url.searchParams.get('code')?.trim().toUpperCase() ?? '';
    return /^[23456789A-HJ-NP-Z]{6,12}$/.test(code) ? code : null;
  } catch {
    return null;
  }
}

export function savePendingChallenge(code: string): void {
  try { localStorage.setItem(STORAGE_KEY, code); } catch { /* unavailable */ }
}

export function consumePendingChallenge(): string | null {
  try {
    const code = localStorage.getItem(STORAGE_KEY);
    if (code) localStorage.removeItem(STORAGE_KEY);
    return code;
  } catch {
    return null;
  }
}

export async function listenForChallengeLinks(onCode: (code: string) => void): Promise<() => void> {
  const initialWebCode = typeof window !== 'undefined' ? parseChallengeCode(window.location.href) : null;
  if (initialWebCode) onCode(initialWebCode);

  try {
    const { Capacitor } = await import('@capacitor/core');
    if (Capacitor.getPlatform() === 'web') return () => {};
    const { App } = await import('@capacitor/app');
    const launch = await App.getLaunchUrl();
    const launchCode = launch?.url ? parseChallengeCode(launch.url) : null;
    if (launchCode) onCode(launchCode);
    const listener = await App.addListener('appUrlOpen', ({ url }) => {
      const code = parseChallengeCode(url);
      if (code) onCode(code);
    });
    return () => { void listener.remove(); };
  } catch {
    return () => {};
  }
}
